import React from 'react'
import { Modal } from 'antd'

import AlertIcon from '../../../../assets/images/ico_erro.svg'
import { getMessage } from '../../../../util/IntlMessages'

const { confirm } = Modal

export const ConfirmationModal = (onConfirmFunc, message) =>
  confirm({
    title: <img src={AlertIcon} alt="Modal de alerta" style={{ marginLeft: '42%' }} />,
    icon: null,
    content: (
      <span style={{ marginLeft: !message ? 90 : 0 }}>{!message ? getMessage('sureToAdd?') : getMessage(message)}</span>
    ),
    cancelButtonProps: {
      style: {
        width: 148,
        borderColor: '#EE778F',
        color: '#EE778F'
      },
      type: 'ghost'
    },
    okButtonProps: {
      className: 'button-action',
      type: 'primary',
      style: {
        marginRight: 20
      }
    },
    okText: getMessage('label.yes'),
    cancelText: getMessage('label.no'),
    onOk() {
      if (onConfirmFunc) {
        onConfirmFunc()
      }
    },
    onCancel() {}
  })
